
import ConfirmationOverlay from '@/components/ConfirmationOverlay.vue';
import { ActionTypes } from '@/store/actionTypes';
import {
    TrailerAssessmentAnswer,
    TrailerAssessmentQuestion,
} from '@/types/TrailerAssessmentQuestion';
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        dotInspectionExpired: {
            type: Boolean,
            default: false,
        },
        showConfirmation: {
            type: Boolean,
            default: false,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
        titleText: {
            type: String,
            default:
                'Is this trailer still DOT compliant <em>and</em> safe to perform the load with?',
        },
    },
    components: {
        ConfirmationOverlay,
    },
    methods: {
        acceptPrompt(): void {
            this.updateAssessmentResponse(true);
            this.$emit('accepted', { didAccept: true });
        },
        rejectPrompt(): void {
            this.updateAssessmentResponse(false);
            this.$emit('accepted', { didAccept: false });
        },
        updateAssessmentResponse(isSafe: boolean): void {
            this.$store.dispatch(
                ActionTypes.UPDATE_TRAILER_ASSESSMENT_QUESTION,
                {
                    question: TrailerAssessmentQuestion.DOT_SAFE,
                    answer: isSafe
                        ? TrailerAssessmentAnswer.YES
                        : TrailerAssessmentAnswer.NO,
                }
            );
        },
    },
});
